(() => {
  if (window.BVDailyCountdown) {
    window.BVDailyCountdown.refresh();
    return;
  }

  function refresh() {
    const clocks = document.querySelectorAll('[data-bv-daily-countdown]');
    if (!clocks.length) return;

    const now = new Date();
    const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    const secondsLeft = Math.max(0, Math.floor((midnight.getTime() - now.getTime()) / 1000));
    const hours = String(Math.floor(secondsLeft / 3600)).padStart(2, '0');
    const minutes = String(Math.floor((secondsLeft % 3600) / 60)).padStart(2, '0');
    const seconds = String(secondsLeft % 60).padStart(2, '0');
    const text = `${hours}:${minutes}:${seconds}`;

    clocks.forEach((clock) => {
      if (clock.textContent !== text) clock.textContent = text;
    });
  }

  window.BVDailyCountdown = { refresh };
  refresh();
  window.setInterval(refresh, 1000);
  document.addEventListener('shopify:section:load', refresh);
})();

if (!customElements.get('bv-cart-session-countdown')) {
  customElements.define('bv-cart-session-countdown', class extends HTMLElement {
    connectedCallback() {
      this.drawer = this.closest('cart-drawer');
      this.key = 'lm-cart-countdown-deadline-v1';
      this.observer = new MutationObserver(() => this.start());
      if (this.drawer) this.observer.observe(this.drawer, { attributes: true, attributeFilter: ['class'] });
      this.start();
    }
    start() {
      if (this.interval || !this.drawer || !this.drawer.classList.contains('active')) return;
      let stored;
      try { stored = Number(sessionStorage.getItem(this.key)); } catch (error) {}
      this.deadline = stored > 0 ? stored : Date.now() + 600000;
      try { sessionStorage.setItem(this.key, String(this.deadline)); } catch (error) {}
      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }
    tick() {
      const remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      const output = this.querySelector('[data-session-time]');
      if (output) output.textContent = String(Math.floor(remaining / 60)).padStart(2, '0') + ':' + String(remaining % 60).padStart(2, '0');
      if (remaining === 0) {
        const label = this.querySelector('[data-session-label]');
        if (label) label.textContent = 'Tiempo finalizado';
        clearInterval(this.interval);
      }
    }
    disconnectedCallback() {
      clearInterval(this.interval);
      this.observer?.disconnect();
    }
  });
}

(() => {
  const endsAt = Date.parse('2026-10-30T23:00:00Z');
  const format = (value) => String(value).padStart(2, '0');
  function refreshShippingOffer() {
    const clocks = document.querySelectorAll('[data-lm-shipping-countdown]');
    if (!clocks.length) return;
    const remaining = Math.max(0, Math.ceil((endsAt - Date.now()) / 1000));
    if (remaining === 0) {
      window.location.reload();
      return;
    }
    const label = format(Math.floor(remaining / 3600)) + ':' + format(Math.floor(remaining % 3600 / 60)) + ':' + format(remaining % 60);
    clocks.forEach((clock) => { if (clock.textContent !== label) clock.textContent = label; });
  }
  refreshShippingOffer();
  window.setInterval(refreshShippingOffer, 1000);
  document.addEventListener('shopify:section:load', refreshShippingOffer);
})();
